// Storefront Order Creation Constants
// Mirrors the Shopify storefront order form (Snaps-Shopify-Theme/sections/order-form.liquid)
// and ORDER_FORM_URL_PARAMS.md. The SKU format produced by buildGeneratedSku is the
// contract the backend uses to resolve stories on webhook import.

// ==================== EGYPTIAN CITIES ====================
// Exactly the 29 valid customer_city values from ORDER_FORM_URL_PARAMS.md, in order.
export const EG_CITIES = [
  '6th of October',
  'Al Sharqia',
  'Alexandria',
  'Aswan',
  'Asyut',
  'Beheira',
  'Beni Suef',
  'Cairo',
  'Dakahlia',
  'Damietta',
  'Faiyum',
  'Gharbia',
  'Giza',
  'Helwan',
  'Ismailia',
  'Kafr el-Sheikh',
  'Luxor',
  'Matrouh',
  'Minya',
  'Monufia',
  'New Valley',
  'North Sinai',
  'Port Said',
  'Qalyubia',
  'Qena',
  'Red Sea',
  'Sohag',
  'South Sinai',
  'Suez'
];

// ==================== SHIPPING OPTIONS ====================
// Prices in EGP, matching the storefront shipping options.
export const SHIPPING_OPTIONS = [
  { value: 'regular', code: 'regular_shipping', title: 'Regular Shipping', price: 100 },
  { value: 'express', code: 'express_shipping', title: 'Express Shipping', price: 400 },
  // Dashboard-only (spec addendum 8.4): free shipping still requires a
  // delivery address but charges nothing. The storefront does not offer it.
  { value: 'free', code: 'free_shipping', title: 'Free Shipping', price: 0 }
];

// Express shipping is only available in these cities.
export const EXPRESS_CITIES = ['Cairo', 'Giza'];

// ==================== PAYMENT METHODS ====================
export const PAYMENT_METHODS = [
  { value: 'online', label: 'Online Payment (Credit / Visa / Debit Card)' },
  { value: 'instapay', label: 'InstaPay' },
  { value: 'mobile_wallet', label: 'Mobile Wallet' },
  { value: 'cod', label: 'Cash on Delivery (COD)' }
];

// ==================== LANGUAGES ====================
export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'Arabic' },
  { code: 'fr', label: 'French' },
  { code: 'de', label: 'German' },
  { code: 'es', label: 'Spanish' },
  { code: 'it', label: 'Italian' }
];

// ==================== LIMITS ====================
export const LIMITS = {
  MAX_STORIES: 30,
  MAX_PHOTOS: 4,
  KID_NAME_MIN: 2,
  KID_NAME_MAX: 15,
  PHOTO_MAX_BYTES: 20 * 1024 * 1024
};

// Accepted photo upload types (mirrors the backend validation):
// JPEG, PNG, WebP, HEIC and HEIF.
export const PHOTO_ACCEPT = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif'
];

// ==================== PER-STORY ADD-ONS ====================
// Mirrors the storefront order form add-ons. `sku` is the SKU suffix / cart
// attribute value used by generateCustomSKU on the storefront; `fallbackPrice`
// is the EGP price used when the cart API is unavailable.
// Premium printing is NOT an add-on: it is a per-variant upgrade sourced from
// the story catalog (variant.premium) and rides on the story line itself.
export const ADDONS = {
  giftBox: { sku: 'gift', label: 'Gift box', fallbackPrice: 500 },
  giftNote: { sku: 'gift-note', label: 'Gift note', fallbackPrice: 200 }
};

// Maximum characters for a gift note message.
export const GIFT_MESSAGE_MAX = 250;
